<template>
    <section class="imported-horses-page">
        <h2 id="imported-horses" class="print-title">Imported Horses</h2>
        <h3 id="years" class="print-title black-title"> {{ yearsRange }} </h3>
        <p class="text-center">Listed in numerical order</p>
        <p class="text-center">Including some late registrations not incuded in previous volumes</p>
    </section>

    <div class="break-after"></div>

    <DataTable class="table-imported-horses" :value="importedHorses" :rowClass="rowClass">
        <Column field="name" header="Name">
            <template #body="slotProps">
                <div class="flex-column">
                    <p class="horse-name">{{ slotProps.data.name }}</p>
                    <p class="no-wrap">{{ slotProps.data.previousStudbookName ? slotProps.data.previousStudbookName : '' }}</p>
                </div>
            </template>
        </Column>

        <Column header="LYSB Reg. Nr.">
            <template #body="slotProps">
                <span>
                    {{ addBrackets(slotProps.data.registryId) }}
                </span>
            </template>
        </Column>
        <Column field="dateOfBirth" header="D.O.B">
            <template #body="slotProps">
                {{ formatDate(slotProps.data.dateOfBirth) }}
            </template>
        </Column>
        <Column field="sex" header="Sex"></Column>
        <Column field="color" header="Color"></Column>
        <Column field="sireFullName" header="Sire">
            <template #body="slotProps">
                <div class="flex-column">
                    <p class="no-margin">
                        <span v-if="slotProps.data.sireFullName"
                              class="horse-name">{{ slotProps.data.sireFullName }}</span>
                        <span v-else>&nbsp;</span>
                    </p>
                    <p class="no-margin" v-if="slotProps.data.breeders">Breeders: {{ slotProps.data.breeders }}</p>
                </div>
            </template>
        </Column>
        <Column body-class="horse-name" field="damFullName" header="Dam"></Column>
        <Column field="importDate" header="Import Date">
            <template #body="slotProps">
                {{ formatDate(slotProps.data.importDate) }}
            </template>
        </Column>
    </DataTable>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {yearFromToMixin} from "@/views/readonly/studbook/util/yearFromToMixin";
import {addBracketsMixin} from "@/views/readonly/studbook/util/addBracketsMixin";

export default {
    name: "ImportedHorsesPage",
    components: {DataTable, Column},
    mixins: [yearFromToMixin, addBracketsMixin],
    props: {
        importedHorses: Array,
    },
    methods: {
        rowClass() {
            return {
                "table-row": false,
            };
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            return dateStr.replace(/-/g, "/");
        },
    },

};
</script>

<style lang="scss" scoped>
.imported-horses-page {
    margin-top: 50% !important;
}

</style>
